import React, { useCallback } from 'react';
import InlineAlertBanner from './InlineAlertBanner';
import { usePwaInstall } from '../hooks/usePwaInstall';

const T = {
  fr: {
    native: 'Installez KIO Admin pour un accès rapide depuis votre écran d\'accueil.',
    ios: 'Installez KIO Admin : touchez Partager puis « Sur l\'écran d\'accueil ».',
    install: 'Installer',
    dismiss: 'Fermer',
  },
  en: {
    native: 'Install KIO Admin for quick access from your home screen.',
    ios: 'Install KIO Admin: tap Share, then "Add to Home Screen".',
    install: 'Install',
    dismiss: 'Dismiss',
  },
  ar: {
    native: 'ثبّت KIO Admin للوصول السريع من الشاشة الرئيسية.',
    ios: 'ثبّت KIO Admin: اضغط مشاركة ثم «إضافة إلى الشاشة الرئيسية».',
    install: 'تثبيت',
    dismiss: 'إغلاق',
  },
};

export default function PwaInstallBanner({ lang = 'fr' }) {
  const { visible, canNativeInstall, isIOS, installing, install, dismiss } = usePwaInstall();
  const t = T[lang] || T.fr;

  const handleInstall = useCallback(async () => {
    await install();
  }, [install]);

  if (!visible) return null;

  const message = isIOS && !canNativeInstall ? t.ios : t.native;

  return (
    <InlineAlertBanner
      message={message}
      actionLabel={canNativeInstall ? t.install : null}
      onAction={canNativeInstall ? handleInstall : undefined}
      loading={installing}
      onDismiss={dismiss}
      dismissLabel={t.dismiss}
    />
  );
}
